import { TopbarLogo } from './styles'

export const Logotipo = ({ width }) => {
  return (
    <TopbarLogo to="/">
      <img src="/logo.png" alt="logotipo Barros Autopeças" style={{ width }} />
    </TopbarLogo>
  )
}
